import { ServiceArticlePage } from "@/components/ServiceArticlePage";
import { SERVICES } from "@/data/content";
import { WEBSITE_DEVELOPMENT_ARTICLE } from "@/data/websiteDevelopment";

const service = SERVICES.find((s) => s.slug === "website-development");

export default function WebsiteDevelopment() {
  return (
    <ServiceArticlePage
      service={service}
      blocks={WEBSITE_DEVELOPMENT_ARTICLE}
      overline="Service guide — I"
      lede="Business website design, responsive development, landing pages, redesigns, maintenance, performance work, basic SEO setup and lead-capture forms — how we approach each, what is included, and how it is priced."
      seoDescription="Website development services from My Geeks LLC: business website design, responsive development, landing pages, redesign, maintenance, performance and basic SEO setup. Request a quote."
    />
  );
}
